var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500.5 500.5",
    enableBackground: "new 0 0 500.5 500.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A3B53",
    d: "M250,455.6c-3.5,0-6.6-1.3-9.3-4L66.5,277.4c-25.7-25.7-39.8-59.9-39.8-96.4s14.1-70.7,39.8-96.4 s60-39.8,96.6-39.8c31.1,0,60.6,10.3,85.5,29.7l1.9,1.5l1.9-1.5c24.3-19.4,53.9-29.7,85.5-29.7c36.1,0,70.4,14.1,96.7,39.8 c25.3,25.8,39.3,60.2,39.3,96.6c0,36.6-14.1,71-39.8,96.6L259.9,451.5C256.6,454.3,253.4,455.6,250,455.6z M163.2,71.4 c-29.8,0-57.6,11.3-78.1,31.8c-20.8,20.8-32.2,48.4-32.2,77.8s11.4,57,32.2,77.8L250,423.8l164.9-164.4 c20.8-21.4,31.8-48.4,31.8-78.1c0-29.6-11.1-57.4-31.2-78.1c-20.5-20.5-48.1-31.8-77.6-31.8c-29.5,0-57,11.3-77.5,31.8 c-2.6,2.6-5.9,4-9.3,4s-6.7-1.4-9.3-4C220.2,82.7,192.2,71.4,163.2,71.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 413.9,
    y: -304.8,
    fill: "none",
    width: 500,
    height: 500
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0f2914c59cfd1e9a3c36b219f6019272.svg";
export { ForwardRef as ReactComponent };